import { Event, EventHint } from '@sentry/types';
import { DISCARD_SENTRY_ERRORS } from './constants';

export const shouldLogEvent = (error: Error): boolean => {
  const { message } = error;

  if (!message) return true;

  const shouldIgnore = DISCARD_SENTRY_ERRORS.some((error) => {
    const re = new RegExp(error, 'i');
    return re.test(message);
  });

  return !shouldIgnore;
};

export const beforeSend = (event: Event, hint: EventHint): Event | null => {
  // filter out the errors we want to ignore
  const error = hint?.originalException;
  if (error && typeof error !== 'string' && !shouldLogEvent(error)) {
    return null;
  }

  return event;
};
